<div class="container">
    <div class="row">
        <div class="col-lg-6 marginBottom2Rem">
            <button mat-raised-button color="accent" [disabled]="!pdfisReadyForDownloading" (click)="generatePDF()"> PDF
                generieren
                <mat-icon *ngIf="pdfIsGenerating">
                    <mat-spinner color="primary" diameter="20">
                    </mat-spinner>
                </mat-icon>
            </button>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Kunden nach Geschlecht
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="!loadedGender" class="loadingContainer">
                        <mat-spinner></mat-spinner>
                    </div>
                    <div *ngIf="loadedGender">
                        <ibm-donut-chart [data]="data_user_gender" [options]="config_donut_users"></ibm-donut-chart>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Kunde nach Status
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="!loadedGender" class="loadingContainer">
                        <mat-spinner></mat-spinner>
                    </div>
                    <div *ngIf="loadedGender">
                        <ibm-donut-chart [data]="data_user_role" [options]="config_donut_users"></ibm-donut-chart>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="col-lg-4">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Kunde hat E-Mail-Adresse angegeben
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="!loadedGender" class="loadingContainer">
                        <mat-spinner></mat-spinner>
                    </div>
                    <div *ngIf="loadedGender">
                        <ibm-donut-chart [data]="data_user_has_mail" [options]="config_donut_users"></ibm-donut-chart>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Kunden nach Stadt (1/2)
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="!loadedCities" class="loadingContainer">
                        <mat-spinner></mat-spinner>
                    </div>
                    <div *ngIf="loadedCities">
                        <ibm-treemap-chart [data]="data_user_city" [options]="treemap_options"></ibm-treemap-chart>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Kunden nach Stadt (2/2)
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="!loadedCities" class="loadingContainer">
                        <mat-spinner></mat-spinner>
                    </div>
                    <div *ngIf="loadedCities">
                        <ibm-circle-pack-chart [data]="data_user_city_2" [options]="circle_pack_options"></ibm-circle-pack-chart>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Kunden nach Geburtsjahr
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="!loadedCities" class="loadingContainer">
                        <mat-spinner></mat-spinner>
                    </div>
                    <div *ngIf="loadedCities">
                        <ibm-treemap-chart [data]="data_user_year" [options]="treemap_options"></ibm-treemap-chart>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Kunden nach Erstellungsdatum
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="!loadedCities" class="loadingContainer">
                        <mat-spinner></mat-spinner>
                    </div>
                    <div *ngIf="loadedCities">
                        <ibm-simple-bar-chart [data]="data_user_year_created" [options]="options_line_year">
                        </ibm-simple-bar-chart>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Kunden nach Altersgruppen
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="!loadedCities" class="loadingContainer">
                        <mat-spinner></mat-spinner>
                    </div>
                    <div *ngIf="loadedCities">
                        <ibm-simple-bar-chart [data]="data_user_year_born" [options]="options_line_agegroup"></ibm-simple-bar-chart>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>


    <div class="row">
        <div class="col-lg-12">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Reservierungen nach Altersgruppen von
                        {{currentEvent?.title | truncate : 50 : false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div *ngIf="!loadedCities" class="loadingContainer">
                        <mat-spinner></mat-spinner>
                    </div>
                    <div *ngIf="loadedCities">
                        <mat-form-field class="full-width">
                            <mat-label>Event auswählen</mat-label>
                            <mat-select (selectionChange)="changeEvent($event)">
                                <mat-option *ngFor="let sortOption of events" [value]="sortOption.publicId">
                                    {{sortOption.title}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <ibm-simple-bar-chart [data]="data_user_year_born_event" [options]="options_line_agegroup"
                            *ngIf="this.data_user_year_born_event.length > 0">
                        </ibm-simple-bar-chart>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <mat-card appearance="outlined" class="form-card">
                <mat-card-header>
                    <mat-card-title class="mingheightCardTitle">Top Kunden von {{currentEvent?.title | truncate : 50 :
                        false}}
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content>                    
                    <div *ngIf="!loadedTables" class="loadingContainer">
                        <mat-spinner></mat-spinner>
                    </div>
                    <table *ngIf="loadedTables" mat-table [dataSource]="dataSource">
                        <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns">
                            <th mat-header-cell *matHeaderCellDef>{{ column }}</th>
                            <td mat-cell *matCellDef="let emp">{{ emp[column] }}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let emprow; columns: displayedColumns"></tr>
                    </table>
                    <mat-paginator #paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons
                        class="paginator-centered"></mat-paginator>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <mat-divider style="width: 100%;margin: 20px 0;"></mat-divider>
        </div>
    </div>
</div>